import { ExperienceTemplateRenderer, getChildByName, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { ViewExtraLarge, ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { useRefProvider } from 'src/common/stores/contexts/ref-provider';

import { FitContent, MinMax, UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkScrollable } from 'uitk-react-scrollable';
import { UitkSpacing } from 'uitk-react-spacing';

export const SRPLayout: React.FC<TemplateComponentProps> = props => {
  const { templateComponent } = props;
  const [searchResultsListRef] = useRefProvider('searchResultsList');

  const childrenForArea = (areaName: string) => {
    const area = getChildByName(templateComponent, areaName);

    return area && area.children ? area.children : [];
  };

  return (
    <ErrorBoundary label="srp.page.layout">
      <UitkLayoutGrid
        areas={{
          small: ['header', 'main'],
          large: ['header header', 'main map'],
          /* eslint-disable camelcase */
          extra_large: ['header header header', 'main map ad'],
        }}
        rows={['auto', '1fr']}
        columns={{
          large: [MinMax('660px', '800px'), MinMax('332px', '400px')],
          /* eslint-disable camelcase */
          extra_large: [MinMax('692px', '864px'), MinMax('348px', '1fr'), FitContent('40x')],
        }}
        blockSize={'100vb'}
      >
        <UitkLayoutGridItem area={'header'}>
          <UitkSpacing border={['blockend']}>
            <header data-stid="header">
              <ErrorBoundary label="header-error-boundary">
                <Viewport>
                  <ViewSmall>
                    <ExperienceTemplateRenderer templateComponents={childrenForArea('header-area-small')} />
                  </ViewSmall>
                  <ViewLarge>
                    <ExperienceTemplateRenderer templateComponents={childrenForArea('header-area')} />
                  </ViewLarge>
                </Viewport>
              </ErrorBoundary>
            </header>
          </UitkSpacing>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem area={'main'}>
          <UitkScrollable direction="vertical">
            <main data-stid="search-results-list" ref={searchResultsListRef}>
              <ErrorBoundary label="main-search-result-list-error-boundary">
                <ExperienceTemplateRenderer templateComponents={childrenForArea('main-area')} />
              </ErrorBoundary>
            </main>
          </UitkScrollable>
        </UitkLayoutGridItem>
        <Viewport>
          <ViewLarge>
            <UitkLayoutGridItem area={'map'}>
              <UitkSpacing margin={{ extra_large: { inlineend: 'six' } }}>
                <aside data-stid="dynamic-search-map">
                  <ErrorBoundary label="dynamic-search-map-error-boundary">
                    <ExperienceTemplateRenderer templateComponents={childrenForArea('map-area')} />
                  </ErrorBoundary>
                </aside>
              </UitkSpacing>
            </UitkLayoutGridItem>
          </ViewLarge>
        </Viewport>
        <Viewport>
          <ViewExtraLarge>
            <UitkLayoutGridItem area={'ad'}>
              {/* adding in-line css here as a quick fix for https://jira.expedia.biz/browse/VRBOSHOP-8206 */}
              <section data-stid="meso-ad" style={{ overflowY: 'hidden' }}>
                <ErrorBoundary label="meso-ad-error-boundary">
                  <ExperienceTemplateRenderer templateComponents={childrenForArea('ad-area')} />
                </ErrorBoundary>
              </section>
            </UitkLayoutGridItem>
          </ViewExtraLarge>
        </Viewport>
      </UitkLayoutGrid>
    </ErrorBoundary>
  );
};
